var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import RightNavigation from "../../components/ui/RightNavigation/RightNavigation";
import Row from "../../components/ui/Row/Row";
import Col from "../../components/ui/Col/Col";
import useBreakpoint from "../../hooks/useBreakpoint";
import { Wrapper } from "../../components/ui/Player/Wrapper";
import { useSelector } from "react-redux";
import { resetSubscribeChannelPresenceThunk, selectAppContent, selectCurrentEpisode, selectDocumentVisibilityStatus, selectPlayerSource, setIsSourceReady } from "@adm-media/adam-store-plugin";
import { useAppDispatch } from "../../store";
import { LIVE } from "../../types/player";
import "./Watch.scss";
import { EpisodeCountdown } from "../../components/blocks/EpisodeCountdown/EpisodeCountdown";
import moment from "moment";
import { setWebsiteTitle } from "../../utils/setWebsiteTitle";
var DEFAULT_PLAYER_PADDING_RIGHT = 80;
export var WatchPage = function (_a) {
    var _b;
    var pusherSingleton = _a.pusherSingleton;
    // always open navbar is active when breakpoint > isTablet
    var _c = useBreakpoint(), isMobile = _c.isMobile, isMiniTablet = _c.isMiniTablet, isTablet = _c.isTablet;
    var navRef = useRef();
    var dispatch = useAppDispatch();
    var documentVisibilityStatus = useSelector(selectDocumentVisibilityStatus);
    var contents = useSelector(selectAppContent);
    var playerSource = useSelector(selectPlayerSource);
    var _d = useSelector(selectCurrentEpisode), countdown_closed_at = _d.countdown_closed_at, episode_title = _d.title;
    var closableSidebar = isMobile || isMiniTablet || isTablet;
    var _e = useState(closableSidebar ? 0 : DEFAULT_PLAYER_PADDING_RIGHT), playerMarginRight = _e[0], setPlayerMarginRight = _e[1];
    var onDreawerToggled = function (width) {
        setPlayerMarginRight(closableSidebar ? 0 : width + DEFAULT_PLAYER_PADDING_RIGHT);
    };
    var _f = useState(!!!countdown_closed_at ? false : moment.tz(countdown_closed_at, "utc").isBefore() ? false : true), showCountdown = _f[0], setShowCountdown = _f[1];
    var _g = useState(true), showPlayer = _g[0], setShowPlayer = _g[1];
    useEffect(function () {
        var _a;
        if (documentVisibilityStatus === "hidden" &&
            playerSource.status === LIVE &&
            ((_a = playerSource.channel) === null || _a === void 0 ? void 0 : _a.is_fake_live) &&
            !!!(document === null || document === void 0 ? void 0 : document.fullscreenElement)) {
            setShowPlayer(false);
            dispatch(resetSubscribeChannelPresenceThunk({}));
            dispatch(setIsSourceReady(false));
        }
        else
            setShowPlayer(true);
    }, [documentVisibilityStatus, playerSource.status, playerSource.channel]);
    useEffect(function () {
        if (episode_title)
            setWebsiteTitle("".concat(contents === null || contents === void 0 ? void 0 : contents.site_title, " | ").concat(episode_title));
        return function () { return setWebsiteTitle(contents === null || contents === void 0 ? void 0 : contents.site_title); };
    }, [episode_title]);
    return (_jsxs("div", __assign({ "data-testid": "watch", className: classNames("watch") }, { children: [_jsx(Row, __assign({ className: "watch__player-container" }, { children: _jsxs(Col, __assign({ span: 24, className: classNames("watch__player-wrapper", (_b = {},
                        _b["watch__player-wrapper--countdown"] = showCountdown,
                        _b)), style: {
                        paddingRight: "".concat(!closableSidebar ? Math.max(playerMarginRight, DEFAULT_PLAYER_PADDING_RIGHT) : 0, "px")
                    } }, { children: [!showCountdown && (showPlayer || documentVisibilityStatus === "visible") && _jsx(Wrapper, { pusherSingleton: pusherSingleton }), showCountdown && _jsx(EpisodeCountdown, { setShowCountdown: setShowCountdown })] })) })), _jsx(RightNavigation, { ref: navRef, onDreawerToggled: onDreawerToggled, isCountdownActive: showCountdown })] })));
};
